export default {
  namespace: 'dmsFenggu',
  namespaced: true,
  state: {},
  mutations: {},
  actions: {},
  modules: {},
};
